import { render, staticRenderFns } from "./tag-edit.component.vue?vue&type=template&id=181c3116"
import script from "./tag-edit.component.vue?vue&type=script&lang=ts"
export * from "./tag-edit.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports